import {Table} from "antd";
import './ResultsTable.css'
import {LineInEnrollment} from "../../../models/LineInEnrollment";
import {useEffect, useState} from "react";

interface IGetResultsResponse {
    code: string
    rollWinners: LineInEnrollment[]
}

interface IProps {
    comp: number
}

let timer: number | null = null

export function ResultsTable(props: IProps) {
    const { comp } = props
    const [enrollmentsMen, setEnrollmentsMen] = useState<LineInEnrollment[]>([])
    const [enrollmentsWomen, setEnrollmentsWomen] = useState<LineInEnrollment[]>([])
    const [render, setRender] = useState(1)


    function scheduleReFetch() {
        if(timer != null) {
            window.clearTimeout(timer)
        }
        timer = window.setTimeout(() => setRender((render) => render + 1) , 10000)
    }

    useEffect(() => {
        fetch(`https://www.4sport-live.com/apis/getWinersRest2/?restPassword=39tOFes4&Rolls=1&comp=${comp}`)
            .then(res => res.json())
            .then(
                (response: IGetResultsResponse) => {
                    const enrollments = response.rollWinners
                    enrollments.forEach(enrollment => enrollment.key = enrollment.number)
                    const men = enrollments.filter(enrollment => enrollment.sex === 'M')
                    for(let i=0;i<men.length;i++) {
                        men[i].RollPlaceSex = i + 1
                    }

                    const women = enrollments.filter(enrollment => enrollment.sex === 'F')
                    for(let i=0;i<women.length;i++) {
                        women[i].RollPlaceSex = i + 1
                    }
                    setEnrollmentsMen(men)
                    setEnrollmentsWomen(women)
                    scheduleReFetch()
                },
                (error) => {
                    scheduleReFetch()
                    console.log(error)
                }
            ).catch((error: any) => {
            scheduleReFetch()
            console.log(error)
        })
    }, [render])

    const columns: any[] = [
        {
            align: 'center' as 'center',
            title: 'מיקום',
            dataIndex: 'RollPlaceSex',
            key: 'RollPlaceSex',
        },
        {
            align: 'center' as 'center',
            title: 'מדינה',
            key: 'country',
            width: '80px',
            render: (_: any, lineInEnrollment: LineInEnrollment) => {
                try {
                    const country = require('../../../assets/countries/' + lineInEnrollment.country.toLocaleLowerCase() + '.svg')
                    return <div className={'country-div'}>
                        <img style={{marginLeft: '-18px', display: 'inline-block'}} className={'country-img'} src={country} alt={'country'}/>
                    </div>
                }
                catch (error) {
                    return <></>
                }
            }
        },
        {
            align: 'right' as 'right',
            title: 'שם',
            key: 'name',
            render: (_: any, lineInEnrollment: LineInEnrollment) => <div>
                <span>{lineInEnrollment.Pname} {lineInEnrollment.Fname}</span>
            </div>,
        },
        {
            align: 'center' as 'center',
            title: 'מספר',
            dataIndex: 'number',
            key: 'number',
        },
        {
            align: 'right' as 'right',
            title: 'זמן',
            key: 'score',
            render: (_: any, lineInEnrollment: LineInEnrollment) => {
                let score = lineInEnrollment.isLeader ? lineInEnrollment.leaderScore : lineInEnrollment.leaderScore
                return <>{score}</>
            },
        },
    ]



    const menLeadersStepName = (enrollmentsMen && enrollmentsMen.length > 0) ? enrollmentsMen[0].leaderStepName : ''
    const womenLeadersStepName = (enrollmentsWomen  && enrollmentsWomen.length > 0) ? enrollmentsWomen[0].leaderStepName : ''

    return (
        <>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 style={{color: 'white', textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: '55px'}}>גברים מרתון</h1>
            <h1 style={{color: 'white', marginTop: '-20px', textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: '35px'}}>{menLeadersStepName}</h1>
            <br/>
            <Table
                columns={columns}
                dataSource={enrollmentsMen}
                className='results_table'
                pagination={false}
                rowClassName={(_record, index) =>
                    index % 2 === 0 ? 'odd-row' : 'even-row'
                }
            />
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 style={{color: 'white', textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: '55px'}}>נשים מרתון</h1>
            <h1 style={{color: 'white', textAlign: 'center', marginTop: '-20px', width: '100%', fontWeight: 'bold', fontSize: '35px'}}>{womenLeadersStepName}</h1>
            <br/>
            <Table
                columns={columns}
                dataSource={enrollmentsWomen}
                className='results_table'
                pagination={false}
                rowClassName={(_record, index) =>
                    index % 2 === 0 ? 'odd-row' : 'even-row'
                }
            />
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </>
    )

}